import axios from 'axios'

const getWeather = async (lat, lng) => {
  let url = 'https://api.open-meteo.com/v1/forecast'
  return await axios.get(url, {
    params: {
      latitude: lat,
      longitude: lng,
      current_weather: true,
      timezone: 'auto',
      temperature_unit: 'fahrenheit',
    },
    withCredentials: false,
  })
}

const getLocationByIp = async () => {
  let url = 'https://freeipapi.com/api/json'
  return await axios.get(url, {
    withCredentials: false,
  })
}

const getAddresses = async (address, layer, countryCode) => {
  if (!address) return;
  let encodedAddress = encodeURIComponent(address);
  let url = `https://api.radar.io/v1/search/autocomplete?query=${encodedAddress}&limit=5&countryCode=${countryCode}&layers=${layer}`;
  return await axios.get(url, {
    headers: {
      Authorization: process.env.VUE_APP_RADAR_PUBLIC_KEY,
    },
    withCredentials: false,
  })
}

export default {
  getWeather,
  getLocationByIp,
  getAddresses,
}
